import React, { useEffect, useState } from "react";
import UserOpsModalShell from "./UserOpsModalShell";

export default function UserBanModal({ open, user, loading, onClose, onConfirm }) {
  const [reason, setReason] = useState("");
  const isBanned = Boolean(user?.isBanned);

  useEffect(() => {
    if (open) setReason("");
  }, [open, user?._id]);

  if (!user) return null;

  const handleConfirm = () => {
    if (!user._id) return;
    onConfirm(user._id, isBanned ? null : reason.trim() || "No reason provided");
  };

  return (
    <UserOpsModalShell
      open={open}
      onClose={onClose}
      eyebrow={isBanned ? "Reinstate" : "Suspension desk"}
      title={isBanned ? "Unban member" : "Ban member"}
      tone={isBanned ? "unban" : "ban"}
      user={user}
      ariaLabel={isBanned ? "Unban user" : "Ban user"}
      footer={
        <>
          <button type="button" className="au-modal-btn au-modal-btn-ghost" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className={`au-modal-btn ${isBanned ? "au-modal-btn-unban" : "au-modal-btn-ban"}`}
            disabled={loading}
            onClick={handleConfirm}
          >
            {loading ? (isBanned ? "Reinstating…" : "Suspending…") : isBanned ? "Confirm unban" : "Confirm ban"}
          </button>
        </>
      }
    >
      {isBanned ? (
        <div className="au-modal-note au-modal-note-success">
          <strong>Account suspended</strong>
          <p>
            This will restore access for <em>{user.name}</em>. They can sign in and use the platform again.
          </p>
          {user.banReason ? (
            <span className="au-modal-note-meta">Prior reason: {user.banReason}</span>
          ) : null}
        </div>
      ) : (
        <>
          <div className="au-modal-note au-modal-note-warn">
            <strong>Immediate suspension</strong>
            <p>The member loses access until manually reinstated. Log a clear reason for audit.</p>
          </div>
          <label className="au-modal-field">
            <span className="au-modal-field-label">Ban reason</span>
            <textarea
              className="au-modal-input au-modal-textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Policy violation, fraud review, etc."
            />
          </label>
        </>
      )}
    </UserOpsModalShell>
  );
}
